import {
    Badge,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
    Text,
} from '@ksyos/design-system';
import { Fragment } from 'react';
import type { IServiceOrganizationGroupHistory } from '@frontend/components/interfaces';
import { getDisplayName } from '@common/utils/getDisplayName';
import { isActiveOnDate } from '@common/utils/isActiveOnDate';
import { NullableFormattedDate } from '@frontend/components/elements/NullableFormattedDate';
import { getSelectedLanguage } from '@frontend/translate';

interface IGroupHistoryTableReadProps {
    columns: string[];
    serviceOrganizationGroupHistory: IServiceOrganizationGroupHistory[];
}

export function GroupHistoryTableRead(props: IGroupHistoryTableReadProps) {
    const { serviceOrganizationGroupHistory, columns } = props;

    return (
        <Box mt={6}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {columns.map((header) => (
                                <TableHeader key={`read-${header}`}>{header}</TableHeader>
                            ))}
                            <TableHeader></TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!!serviceOrganizationGroupHistory.length &&
                            serviceOrganizationGroupHistory.map((serviceOrganizationGroup) => {
                                const isInactive = serviceOrganizationGroup.isDeleted;

                                return (
                                    <Fragment key={`read-${serviceOrganizationGroup.id}`}>
                                        <TableRow>
                                            <TableCell color={isInactive ? 'minimal' : 'subtle'}>
                                                {serviceOrganizationGroup.serviceGroupSetting?.group.name}
                                            </TableCell>
                                            <TableCell color={isInactive ? 'minimal' : 'subtle'}>
                                                {serviceOrganizationGroup.lastUpdatedByPractitioner ? (
                                                    <>
                                                        {`${getDisplayName(
                                                            serviceOrganizationGroup.lastUpdatedByPractitioner,
                                                            false,
                                                            'nameGivenNameFamily'
                                                        )} ${getSelectedLanguage().common.onDate} `}
                                                        <NullableFormattedDate
                                                            value={serviceOrganizationGroup.updated_at}
                                                        />
                                                    </>
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell color={isInactive ? 'minimal' : 'subtle'}>
                                                <NullableFormattedDate value={serviceOrganizationGroup.startDate} />
                                                <Text
                                                    as="span"
                                                    color="inherit"
                                                    mx={2}
                                                    size="sm"
                                                >
                                                    {getSelectedLanguage().common.until}
                                                </Text>
                                                {serviceOrganizationGroup.endDate ? (
                                                    <NullableFormattedDate value={serviceOrganizationGroup.endDate} />
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {isActiveOnDate(serviceOrganizationGroup, new Date()) &&
                                                    !serviceOrganizationGroup.isDeleted && (
                                                        <Badge
                                                            color="green"
                                                            size="small"
                                                            text="Huidige"
                                                        />
                                                    )}
                                                {serviceOrganizationGroup.isDeleted && (
                                                    <Badge
                                                        color="neutral"
                                                        size="small"
                                                        text="Verwijderd"
                                                    />
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    </Fragment>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
